<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="用户评分" prop="rating">
				<el-select v-model="query.rating">
					<el-option v-for="item in 5" :key="item" :label="item" :value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="邮箱地址" prop="email">
				<el-input v-model="query.email" placeholder="请输入邮箱地址" clearable />
			</el-form-item>
		</template>
		<template slot="columns">
			<el-table-column label="用户评分" align="center" prop="rating">
				<template slot-scope="{ row }">
					<el-rate v-model="row.rating" disabled show-score text-color="#ff9900" score-template="{value}">
					</el-rate>
				</template>
			</el-table-column>
			<el-table-column label="反馈内容" align="center" prop="comment" show-overflow-tooltip />
			<el-table-column label="邮箱地址" align="center" prop="email" />
			<el-table-column label="反馈时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="140">
				<template slot-scope="{ row }">
					<el-link :underline="false" type="primary" @click="handleView(row)">
						查看
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, detail } from "@/api/feedback";
import listMixin from '@/mixins/list';
import utils from "@/jslibs/utils";
import Product from "@/components/Product";
import Battery from "@/components/Battery";

export default {
	components: { Product, Battery },
	data() {
		return {
			// 查询参数
			query: {
				word: "",
				status: undefined
			},
			ids: []
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleExport() {
			excel(this.query).then(res => {
				const blob = new Blob([res]);
				const fileName = `邮件列表.xls`;
				utils.downloadBlobFile(blob, fileName);
			});
		},
		handleView(row) {
			this.$router.push({ path: "/feedback/detail", query: { id: row.id } });
		}
	},
};
</script>